/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrderLogisticsInfoVO { 
    /**
     * Logistics account ID
     */
    accountId?: number;
    /**
     * Logistics provider ID
     */
    providerId?: number;
    /**
     * Logistics provider name (e.g, Viettel Post)
     */
    providerName?: string;
    /**
     * Delivery service code (e.g, STD, FAST, EXP)
     */
    serviceCode?: string;
    /**
     * Delivery service name (e.g, Standard Delivery, Express Delivery)
     */
    serviceName?: string;
    /**
     * Tracking number
     */
    logisticsNo?: string;
    /**
     * Delivery status
     */
    logisticsStatus?: OrderLogisticsInfoVO.LogisticsStatusEnum;
    /**
     * Expected delivery time
     */
    expectedDeliveryTime?: string;
    /**
     * Additional note for delivery (e.g, fragile goods, call before delivery,...)
     */
    deliveryNote?: string;
    /**
     * Package length by cm
     */
    length?: number;
    /**
     * Package width by cm
     */
    width?: number;
    /**
     * Package height by cm
     */
    height?: number;
    /**
     * Package weight by grams
     */
    weight?: number;
    /**
     * Total shipping fee
     */
    totalFee?: number;
    /**
     * Cash on delivery amount (e.g, 10000, 50000)
     */
    codAmount?: number;
    /**
     * Declared order value used for insurance and claims (e.g, 10000, 50000)
     */
    declaredValue?: number;
    /**
     * Logistics status description
     */
    logisticsStatusDescription?: string;
    /**
     * Failure reason description from logistics provider
     */
    failureReasonDescription?: string;
    /**
     * Current location from logistics provider
     */
    currentLocation?: string;
}
export namespace OrderLogisticsInfoVO {
    export const LogisticsStatusEnum = {
        Pending: 'PENDING',
        Created: 'CREATED',
        PickedUp: 'PICKED_UP',
        InTransit: 'IN_TRANSIT',
        OutForDelivery: 'OUT_FOR_DELIVERY',
        Delivered: 'DELIVERED',
        DeliveryFailed: 'DELIVERY_FAILED',
        Cancelled: 'CANCELLED',
        Returning: 'RETURNING',
        Returned: 'RETURNED',
        LockedTimeout: 'LOCKED_TIMEOUT'
    } as const;
    export type LogisticsStatusEnum = typeof LogisticsStatusEnum[keyof typeof LogisticsStatusEnum];
}


